import { useMq } from 'vue3-mq';
import { reactive, ref, watch } from 'vue';

export const useMqService = () => {
  const mq = useMq();

  const isMobile = ref(mq.current === 'sm' || mq.current === 'xs');
  const isTablet = ref(mq.current === 'md');
  const isDesktop = ref(mq.current === 'lg' || mq.current === 'xl' || mq.current === 'xxl');
  const isDesktopWide = ref(mq.current === 'xxl');

  watch(
    () => mq.current,
    (value) => {
      isMobile.value = value === 'sm' || value === 'xs';
      isTablet.value = value === 'md';
      isDesktop.value = value === 'lg' || value === 'xl' || value === 'xxl';
      isDesktopWide.value = value === 'xxl';
    },
  );

  return reactive({
    isMobile,
    isTablet,
    isDesktop,
    isDesktopWide,
  });
};

export default useMqService;
